module.exports = __webpack_public_path__ + "static/media/1.eb5182de.png";